<app-header (sidebarToggleEvent)="onSidebarToggle($event)" [sidebarToggled]="sidebarToggled"></app-header>
<!--this was the previous version of the header and sidebar - not used on our brands -->
<div *ngIf="isRival" class="main-section" [ngClass]="{'pushed-down': !token}" style="margin-top: 56px;">
  <div class="collapse shadow bg-darker" [ngClass]="{'show sticky-sidebar': sidebarToggled, 'with-token': token}">
    <app-sidebar style="overflow-y: auto;" (closeSidebarEvent)="onSidebarToggle(false)"></app-sidebar>
  </div>

<!--  refactor header/sticky-main if we want the footer sticked to the bottom if there is insufficient content, mostly on bigger screens todo-->
<!--  <div [ngClass]="{'sticky-main': sidebarToggled}" class="d-flex flex-column" style="min-height: calc(100vh - 56px);">-->
<!--    <div class="flex-grow-1">-->
<!--      <router-outlet></router-outlet>-->
<!--    </div>-->
<!--    <app-footer></app-footer>-->
<!--  </div>-->
  <div [ngClass]="{'sticky-main': sidebarToggled}">
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </div>
</div>

<div *ngIf="!isRival">
  <div class="collapse shadow bg-darker" [ngClass]="{'show sticky-sidebar': sidebarToggled, 'with-token': token}" id="sidebar-wrapper">
    <app-sidebar style="overflow-y: auto;" (closeSidebarEvent)="onSidebarToggle(false)"></app-sidebar>
  </div>

  <div [ngClass]="{'sticky-main': sidebarToggled, 'with-token': token}" id="main-wrapper">
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </div>
</div>
